import React, { Component } from 'react';

import { Button } from 'carbon-components-react';
import { Delete16 } from '@carbon/icons-react';

export default class Attachment extends Component {
  render() {
    const { file, index } = this.props;
    return (
      <div className="attachment-wrapper">
        <div className="attachment">
          <div className="attachment-thumbnail-container">
            <img className="attachment-thumbnail" src={file.objectURL} alt='attachment thumbnail'/>
          </div>
          <div className="attachment-name">{file.name}</div>
          <div className="attachment-actions">
            {file.uploadProgress == null ?
              <Button
                onClick={() => this.props.onDelete(index)}
                size="small"
                renderIcon={Delete16}
                iconDescription="Delete"
                kind="ghost"
              />
              :
              null
            }
          </div>
        </div>
        <div className="progress-bar">
          {!!file.uploadProgress ?
            <div className="progress-bar-level" style={{width: `${file.uploadProgress}%`}}/>
            : null
          }
        </div>
      </div>
    );
  }
}

